import React, { useRef, ReactNode, useEffect, memo } from 'react';

import { Paper } from 'e100-react-components';

import { MAP_INFO_WINDOW_ID } from '../../constants';

import { GoogleMap, HereMap } from 'common/utils';

import { useMediaQuery } from 'common/hooks';
import { useUpdateInfoWindow } from '../../hooks';
import { useMapContext } from 'entities/map';
import { useStyles } from './styles';

export const MapInfoWindow = memo(({
  coordinates,
  children,
  onClose,
  onOpen = () => {},
  showCloseIcon
}: MapInfoWindowProps) => {
  const { map } = useMapContext();
  const { isMobile } = useMediaQuery();
  const classes = useStyles({ isMobile });
  const rootRef = useRef<RootElementRef>(null);

  useUpdateInfoWindow({
    coordinates,
    rootRef,
    showCloseIcon
  }, {
    onClose
  });

  useEffect(() => {
    onOpen();
  // eslint-disable-next-line 
  }, []);

  if (map instanceof HereMap) {
    return (
      <div className={classes.container}>
        <div
          ref={rootRef}
          id={MAP_INFO_WINDOW_ID}
        >
          {children}
        </div>
      </div>
    )
  }

  if (map instanceof GoogleMap) {
    return (
      <>
        <div
          className={classes.root}
          ref={rootRef}
          id={MAP_INFO_WINDOW_ID}
        >
          <Paper
            classes={{
              root: classes.paperRoot
            }}
          >
            {children}
          </Paper>
        </div>
      </>
    );
  }

  return null;
});

export type RootElementRef = HTMLDivElement | null;

export interface MapInfoWindowProps {
  coordinates?: [number, number] | null, // [latitude, longtitude]
  children: ReactNode;
  onClose?: () => void;
  onOpen?: () => void;
  showCloseIcon?: boolean
}